// Copyright (c) 2015, Xhive LLC
// MIT License. See license.txt

import FileUploader from "./file_uploader";

xhiveframework.provide("xhiveframework.ui");
xhiveframework.ui.FileUploader = FileUploader;
